import Vue from 'vue'
import Vuex from 'vuex'

import lottery from './lottery';
import service from './service';
import trend from './trend';
import news from './news';

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        lottery,
        service,
        news,
        trend,
    },
})

export default store